module.exports = __webpack_public_path__ + "img/rectangle-code.d136b26e.svg";